
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonSpinner, IonIcon, IonInput, modalController, menuController, alertController } from "@ionic/vue";
import { ref, computed } from "vue";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import { refresh, menu } from "ionicons/icons";

import { dateFormat } from "@/services/utils";
import { openToast } from "@/services/toast";
import apiMateriali from "@/services/materiali";
import moment from "moment";

export default {
    name: "Materiali",
    components: {
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonPage,
        IonButtons,
        IonButton,
        IonSpinner,
        IonIcon,
        IonInput
    },
    setup() {
        const dipendenteID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_id;
        const loading = ref(false);

        const openMenu = () => {
            menuController.open("app-menu");
        };

        /**
         * Get all automezzi from the server (refresh icon)
         */
        const assegnazioni = ref([]);
        const searchQuery = ref("");
        const searchedAssegnazioni = computed(() => {
            const term = searchQuery.value.toLowerCase().replace(/ /g, "");
            if (!term) {
                return assegnazioni.value;
            }

            return assegnazioni.value.filter((assegnazione) => {
                const name = assegnazione.fw_products_name ? assegnazione.fw_products_name : "";
                return name.toLowerCase().replace(/ /g, "").includes(term);
            });
        });
        async function loadAssegnazioni() {
            loading.value = true;
            try {
                const res = await apiMateriali.getAssegnazioni(dipendenteID);
                if (res.status === 200 && res.data.status === 0) {
                    assegnazioni.value = res.data.data;
                } else {
                    openToast("Si è verificato un errore durante la richiesta dei materiali assegnati", "toast_danger");
                }
                //console.log(assegnazioni.value);
            } catch (error) {
                console.error(error);
                openToast("Si è verificato un errore durante la richiesta dei materiali assegnati", "toast_danger");
            }
            loading.value = false;
        }
        loadAssegnazioni();

        /**
         * Set ricezione of the materiale
         */
        const block_click = ref(false);
        async function handleSetAssegnazione(assegnazione) {
            if (block_click.value) {
                return;
            }

            if (
                assegnazione.assegnazioni_materiale_ricevuto 
                && assegnazione.assegnazioni_materiale_ricevuto == 1
            ) {
                return;
            }

            block_click.value = true;
            const alert = await alertController.create({
                header: "Conferma",
                message: "Confermi di aver ricevuto questo materiale?",
                backdropDismiss: false,
                buttons: [
                    {
                        text: "No",
                        role: "cancel",
                    },
                    {
                        text: "Si",
                        role: "confirm",
                    },
                ],
            });

            try {
                await alert.present();
                const { role } = await alert.onDidDismiss();
                if (role !== "confirm") {
                    return;
                }

                const data_ricezione = moment().format("YYYY-MM-DD");
                const res = await apiMateriali.setAssegnazione(assegnazione.assegnazioni_materiale_id, data_ricezione);
                if (res.status === 200 && res.data.status === 0) {
                    const updated = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                    const idx = assegnazioni.value.findIndex(
                        (item) => item.assegnazioni_materiale_id === assegnazione.assegnazioni_materiale_id
                    );
                    if (idx !== -1) {
                        assegnazioni.value[idx] = {
                            ...assegnazioni.value[idx],
                            ...(updated || {}),
                            assegnazioni_materiale_ricevuto: 1,
                        };
                    }
                    openToast("Ricezione materiale salvata con successo", "toast_success");
                } else {
                    openToast("Non è stato possibile comunicare la ricezione del materiale", "toast_danger");
                }
            } catch (error) {
                console.error(error);
                openToast("Non è stato possibile comunicare la ricezione del materiale", "toast_danger");
            } finally {
                block_click.value = false;
            }
        }


        const tipoMovimento = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    className = "badge_ricevuto";
                } else if (statusId == 2) {
                    className = "badge_non_ricevuto";
                }
                return className;
            };
        });

        return {
            dateFormat,
            refresh,
            loading,
            assegnazioni,
            searchQuery,
            searchedAssegnazioni,
            handleSetAssegnazione,
            menu,
            openMenu,
            loadAssegnazioni,
            tipoMovimento,
        };
    },
};
